import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import ShortcutLink from "../common/ShortcutLink";
import {UserContext} from "../common/UserContext";
import {BrandContext} from "../common/BrandContext";
import {TemplateContext} from "../common/TemplateContext";
import Button from "../common/Button";
import useCurrentShortcut from "../hooks/useCurrentShortcut";

const LastLessonDashboardWidget = props => {
    const {...other} = props;
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {singlePage} = useContext(TemplateContext);
    const [lastConcept, setLastConcept] = useState();
    const [isLoading, setLoading] = useState(true);
    const {loadShortcutByUrl} = useCurrentShortcut();

    const loadLastConcept = () => {
        setLoading(true);
        axios.get('/web/ui/dashboard/lastConcept')
            .then(response => {
                setLastConcept(response.data);
                setLoading(false);
            });
    }

    useEffect(() => {
        loadLastConcept();
    }, []);

    useEffect(() => {
        //$('.ch-dashboard-blk-body.ch-mathjax').reloadMathJax();
    });

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#navLessons-icon"></use>
                    </svg>
                    <span>{user.syllabusName}</span>
                </div>
            }
            isLoading={isLoading}
            {...other}>
            <>
                {lastConcept &&
                    <>
                        <div className={'ch-dashboard-blk-body ch-mathjax'}>
                            <p>
                                <span className={'ch-dashboard-blk-subhead'}>Last {brandConfig.conceptName} viewed</span>
                            </p>
                            <p className="ch-dashboard-lesson-link">
                                {lastConcept.syllabusName} <span className="material-icons">chevron_right</span>
                                {lastConcept.topicName} <span className="material-icons">chevron_right</span>
                                <ShortcutLink className="ch-highlight" shortcutUrl="/web/ui/view/lastLesson">
                                    <span className="ch-mathjax" dangerouslySetInnerHTML={{ __html: lastConcept.conceptName}} />
                                </ShortcutLink>
                            </p>
                            <p>
                                <span className={'text-muted'}>{user.dateTimeFormat.format(user.sessionEndDate)}</span>
                            </p>
                        </div>
                        <div className={'ch-dashboard-blk-footer align-right'}>
                             <Button type="text" onClick={() => loadShortcutByUrl('/web/ui/view/course')}>View</Button>
                        </div>
                    </>
                }
                {!lastConcept &&
                    <div className={'ch-dashboard-blk-body'}>
                        <div className="ch-list-item-disabled">You have not viewed any {brandConfig.conceptsName}</div>
                    </div>
                }
            </>
        </DashboardWidget>
    )
}

export default LastLessonDashboardWidget;